export default {
  relationships: {
    vehicle_features: {
      type: 'vehicle_features',
    },
    photos: {
      type: 'photos'
    }
  }
}